module.exports = __webpack_public_path__ + "static/media/unlink.c6c2db2d.svg";